import { mapState, mapActions } from 'vuex';
import { i18n } from 'lib/i18n.js';
import Klaviyo from 'lib/klaviyo.js';
import { decodeObjectID, formatPrice, decode } from 'utils/general';
import validate from 'mixins/validate';
import { trackGetNotified } from 'lib/tracking';

export default {
  components: {
    'text-input': () => import('../text-input/text-input.vue'),
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    checkbox: () => import('../checkbox/checkbox.vue'),
  },
  i18n,
  mixins: [validate],
  data() {
    return {
      shouldSubscribe: false,
      finalMessage: '',
      formErrors: [],
    };
  },
  computed: {
    ...mapState('global', ['backInStock']),
    title() {
      return this.product?.title?.split(window.__GLOBAL__.productDelimiter)[0];
    },
    variantTitle() {
      if (this.product.variants?.length > 1) {
        return this.variant.title;
      } else if (
        this.variant?.title &&
        this.variant?.title !== 'Default Title'
      ) {
        return this.variant?.title;
      } else {
        return this.product?.title?.split(
          window.__GLOBAL__.productDelimiter,
        )[1];
      }
    },
    product() {
      if (typeof this.backInStock.product === 'string') {
        return JSON.parse(decode(this.backInStock.product));
      }
      return this.backInStock.product;
    },
    variant() {
      return this.backInStock.variant;
    },
    formattedDiscountPrice() {
      if (!this.backInStock.variant || !this.backInStock.variant.compareAtPrice)
        return false;
      return formatPrice(this.price, true);
    },
  },
  methods: {
    ...mapActions('global', ['closeModal']),
    onEmailChange() {
      this.valueChange();
    },
    handleTracking() {
      dataLayer.push({
        event: 'product_module_interaction',
        module_name: 'notify_me',
        click_action: 'notify_me_submit',
        product_name: this.title,
        shopify_module_name: 'product back in stock'
      });
    },
    async addToWaitList() {
      const formData = this.formData();
      const email = formData.email.toString();
      const productId = this.product?.id.toString();
      const productSKU =
        typeof this.product.sku !== 'undefined'
          ? this.product.sku
          : this.product.variants
            ? this.product.variants[0].sku
            : undefined;
      let variantId = this.variant?.id;

      // Check if it's a base64 style ID from storefront that needs decoding (as will be on PDP)
      const base64 = /[a-zA-Z]/g;
      if (base64.exec(variantId) !== null) {
        variantId = decodeObjectID(this.variant?.id, 'ProductVariant');
      }

      if (productId && variantId && email) {
        this.formErrors = [];
        try {
          const requests = [
            Klaviyo.backInStockSubscribe({
              email,
              variant: variantId
            }),
          ];

          if (this.shouldSubscribe && __GLOBAL__.klaviyoListId) {
            requests.push(
              Klaviyo.subscribe({
                email,
                list_id: __GLOBAL__.klaviyoListId,
                source: 'Back in Stock Notification'
              })
            );
          }

          const responses = await Promise.all(requests);
          if (responses[0].status === 202) {
            this.finalMessage = this.$t('products.waitlist.success_description');
            trackGetNotified(productSKU);
            this.handleTracking();
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        console.warn('Issue absorbing product data');
      }
    },
    onCheckboxChange({ value }) {
      this.shouldSubscribe = !!value;
    },
    formatPrice,
  },
  mounted() {
    this.finalMessage = '';
    this.formErrors = [];
  },
};
